export const getIsUserRole = (userRoles) => userRoles?.every((role) => role.slug === 'user' || role.slug === 'a_user');
export const getIsCAdminRole = (userRoles) => userRoles?.some((role) => role.slug === 'c_admin');
